<template>
<b-col cols="12">


  <b-row class="text-center m-4 align-items-center">
      <b-col md="8">
          <h5><strong>{{$ml.get('visutoolt1exo')}}</strong></h5>

          <p style="text-align:justify" v-html="$ml.get('visutoolp1exo')"></p>

              <ol class="center" style="margin: 10px">
                  <li style="margin-bottom:10px; text-align:justify">
                      {{$ml.get('visutoolli1exo')}}<br/>
                      <vue-markdown style="overflow: auto;"  @rendered="onrender">
  ```gradle
  repositories {
      ...
      maven {
          url 'https://maven.quanteec.com/repository/internal/'
          credentials {
              username "username"
              password "password"
          }
          authentication {
              basic(BasicAuthentication)
          }
          maven { url 'https://jitpack.io' }
      }

  }
  ```               
                      </vue-markdown>

                  </li>
                  <li style="margin-bottom:10px; text-align:justify">
                      {{$ml.get('visutoolli2exo')}}<br/>
                      <vue-markdown style="overflow: auto;"  @rendered="onrender">
  ```gradle
  repositories {
    dependencies {
          ...
          implementation ("com.quanteec:quanteecExoVisualize:1.0")

      }

  }
  ```               
                      </vue-markdown>
                  </li>
                  <li style="margin-bottom:10px; text-align:justify">
                      {{$ml.get('visutoolli3exo')}}<br/>
                      <vue-markdown style="overflow: auto;"  @rendered="onrender">
                        
  ```kotlin
  //1. Instantiate the visualization tool
  val visuTool = QuanteecVisualize(quanteecCore)
  //2. Display the tool
  visuTool.DisplayVisualizationTool();
  ```             
                      </vue-markdown>
                  </li>
              </ol>
          <p style="text-align:justify" v-html="$ml.get('visutoolp2exo')"></p>
      </b-col>
      <b-col md="4">
          <b-img style="max-width:450px; border-radius:0.5rem" :src="require('@/assets/VisualizationTool/toolExo.png')"></b-img>
      </b-col>
  </b-row>

</b-col>
</template>
<script>
import VueMarkdown from 'vue-markdown';
import Prism from 'prismjs';
import 'prismjs/themes/prism-twilight.css';
import 'prismjs/components/prism-kotlin.js';
import 'prismjs/components/prism-gradle.js';
export default {
  name: 'VisualizationTool',
  data: function() {
    return {
        line1_script: '<script src="https://files.quanteec.com/vizualisation/latest/quanteec-visualize.min.js"><'+'/script>',
        line2_script: '<div id="quanteec-visualize-tool"></div>',
        line3_script: '<div id="quanteec-visualize-tool" style="font-size: 10px;"></div>',
        line4_script: '<div id="quanteec-visualize-tool" quanteecShow="less"></div>',
        bookmarklet: 'javascript:(function(){var t=document.getElementById("quanteec-visualize-tool");if(t) {t.remove();var x=document.getElementById("quanteec-tool-script");if (x){x.remove()};}else{var e=document.createElement("script");t=document.createElement("div"),e.src="https://files.quanteec.com/visualization/latest/quanteec-visualize.min.js",e.setAttribute("id","quanteec-tool-script");t.setAttribute("id","quanteec-visualize-tool"),t.style.padding="10px",t.style.position="fixed",t.style.bottom="0%",t.style.right="0%",t.style.width="100%",t.style.height="70%",t.style.maxWidth="621px",t.style.maxHeight="500px",t.style.backgroundColor="rgba(255,255,255,0.7)",    t.style.zIndex="2147483647",document.body.appendChild(e),document.body.appendChild(t)}})();'
    }
  },
  props: [
      "isAndroid"
  ],
  components: {
      VueMarkdown
  },
  mounted: function() {

    this.$nextTick(() => {
        Prism.highlightAll()
      });  
  },
  methods: {
    cleanMyTimeout() {
      try {
        clearTimeout(this.timeout);
      } catch(err) {}
    },

    copyToClipboard(text) {
      this.cleanMyTimeout();
      this.$copyText(text);
      this.showModal("copied");
      this.timeout = setTimeout(this.hideModal, 1.5 * 1000, 'copied');
    },
    showModal(modal) {
      this.$refs[modal].show();
    },
    hideModal(modal) {
      this.$refs[modal].hide();
    },
    onrender() {
        this.$nextTick(() => {
        Prism.highlightAll()
      });  
     }  

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>